export default {"name":"NovaComponents-RadioButtonGroup-gui-icu","NovaComponents-RadioButtonGroup-gui-icu.readOnly.aria":"read only"}